// extracted by mini-css-extract-plugin
module.exports = {"Item":"Category_Item__3l3cK","Active":"Category_Active__tAGj8","First":"Category_First__3KIaA"};